/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Toast_Done_OkInputs */

const vi_cdo_toast_done_ok = /** @type {(inputs: Cdo_Toast_Done_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã giao xong`)
};

/**

* @param {Cdo_Toast_Done_OkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_toast_done_ok = /** @type {((inputs?: Cdo_Toast_Done_OkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Toast_Done_OkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_toast_done_ok(inputs)
});